import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import {
    CURSOR
} from 'src/styles/fonts/MCFontConstants';
export const useStyles = makeStyles((theme) => ({
    '@global': {
        '.MuiAutocomplete-option[data-focus="true"]': {
            background: 'none',
        },
    },
    dynamicHeight: {
        maxHeight: ({ dropdownHeight }) =>
            dropdownHeight != undefined ? dropdownHeight : 'unset',
    },
    listRoot: {
        overflowY: 'scroll',
        '&::-webkit-scrollbar': {
            width: 7,
            display: 'block !important',
        },
        // '&::-webkit-scrollbar-track': {
        //     boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
        // },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#00000029',
            borderRadius: '25px',
        },
    },
    options: {
        '&.MuiAutocomplete-option': {
            padding: ({ quickOrderPadding }) =>
                quickOrderPadding ? quickOrderPadding: '0',
            
        },
        '&.MuiAutocomplete-option:hover': {
            backgroundColor: ({ hoverBgColor }) =>
                hoverBgColor ? hoverBgColor : '#CFE8FE',
        },
        '&.MuiAutocomplete-option:active': {
            backgroundColor: 'unset !important',
        },
        '&[aria-selected="true"]': {
            backgroundColor: '#CFE8FE',
        },
    },
    popper: {
        '&.MuiAutocomplete-popper': {
            zIndex: ({ zIndex }) => (zIndex ? zIndex : 9999),

            // boxShadow: '0px 3px 6px #00000029',
        },
        '&.MuiAutocomplete-popper .MuiAutocomplete-paper .MuiAutocomplete-noOptions':
            {
                padding: ({ optionPadding }) =>
                    optionPadding ? optionPadding : '12px 12px',
                // padding: '0px',
            },
    },
    customTextField: {
        '& input': {
            paddingLeft: ({ paddingLeft }) =>
                paddingLeft ? paddingLeft : '10px',
            fontSize: ({ fontSize }) => (fontSize ? fontSize : '16px'),
            fontFamily: 'AvenirNextWorld Regular',
            [theme.breakpoints.down(576)]: {
                paddingLeft: ({ mbPaddingLeft, value }) =>
                    value ? '10px' : mbPaddingLeft,
            },
        },
        '& input::placeholder': {
            fontSize: ({ fontSizePlaceholder }) =>
                fontSizePlaceholder ? fontSizePlaceholder : '16px',
            color: '#8f8f8f',
            opacity: 0.6,
            fontFamily: 'AvenirNextWorld Regular',
        },
        '&.MuiOutlinedInput-root': {
            [theme.breakpoints.down(576)]: {
                borderRadius: ({ mbBorderRadius }) =>
                    mbBorderRadius ? mbBorderRadius : '',
            },
        },
        '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
            {
                border: ({ border }) => (border ? border : '2px solid #EBEDED'),
            },
    },
    paper: {
        '&.MuiAutocomplete-paper': {
            padding: '6px 0 0 0',
            // margin for mobile devices
            '@media (max-width: 450px)': {
                marginLeft: ({ marginLeftOption }) =>
                    marginLeftOption && marginLeftOption, // override for small screens
            },

            marginTop: '-10px',
        },
        '&.MuiPaper-elevation1': {
            boxShadow: '0px 7px 6px #00000029',
        },
    },
    detailsPaper: {
        '&.MuiAutocomplete-paper': {
            margin: 0,
            marginLeft: ({ marginLeft }) => (marginLeft ? marginLeft : 'unset'),
        },
    },
    endAdornment: {
        '&.MuiAutocomplete-endAdornment': {
            display: ({ closeIconDisplay }) => closeIconDisplay,
        },
    },
    // notchedOutline: {
    //     '&.MuiOutlinedInput-notchedOutline': {
    //         border: '2px solid #EBEDED',
    //     },
    // },
}));

export const Icon = styled.img.attrs((props) => ({
    src: props.src,
    onClick: props.onClick,
}))`
    height: ${({ height }) => (height ? height : '15px')};
    opacity: ${({ opacity }) => (opacity ? opacity : '1')};
    cursor: ${CURSOR};
`;
export const DivContainer = styled.div`
    width: ${({ width }) => width};
    height: ${({ height }) => height};
    position: ${({ position }) => (position ? position : 'relative')};
    @media only screen and (min-device-width: 667px) and (max-device-width: 1023px) and (orientation : landscape) {
        width: ${({ landscapeWidth }) => landscapeWidth};
        height: ${({ landscapeHeight }) => landscapeHeight};
    }

   
    }
`;

export const InputContainer = {
    background: ({ backgroundDisabled, backgroundInactive }) =>
        backgroundDisabled
            ? '#F1F1F1'
            : backgroundInactive
            ? backgroundInactive
            : '#ffffff 0% 0% no-repeat padding-box',

    height: '40px',
    // width: '98%',
    // height: '40px',
    width: '100%',
    backgroundColor: '#ffffff',
    // height: ({ height }) => (height ? height : '40px'),
};

// export const InputContainerMob = {
//     height: '40px',
//     width: '100%',
//     backgroundColor: '#ffffff',
//     // height : ({ height }) => (height ? height : '40px'),
// };
